require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./commercial-crimes-unit.json") })
        }
      }, "path---commercial-crimes-unit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---commercial-crimes-unit!./.cache/json/commercial-crimes-unit.json
// module id = 858
// module chunks = 231608221292675